import React from 'react'
import translate from 'core/translate'
import { cn } from 'ethcss'
import styles from './deviceSettings__modBusSettings.jcss'
import EditText from '../../../blocks.simple/editText/editText'
import { SwitchButton } from '../../../atoms/SwitchButton'
import { Typography } from '../../../atoms/Typography'
import grid from '../../../blocks.simple/grid/grid.jcss'
import { Radio } from '../../../atoms/Radio'

export const ModBusSettings = (p_: {
    modBus: any
    className?: string | object
    onChange: (data: any) => void
    enabled: boolean
}) => {
    if (!p_.enabled || !p_.modBus) {
        return null
    }

    const onDataChange = (id: string, value: any, type: string) => {
        p_.onChange(
            p_.modBus.map((modBus: any) => {
                if (modBus.id === id) {
                    return { ...modBus, [type]: value }
                }
                return modBus
            })
        )
    }
    const isTinkoffElevatorSettings = (value: string) => {
        return value === 'tinkoffLift'
    }

    return (
        <div className={cn(p_.className)}>
            {Array.isArray(p_.modBus) &&
                p_.modBus.map((modBus: any) => (
                    <div className={cn(styles.border, grid.mb_md)} key={modBus.id}>
                        <div className={cn(grid.mt_micro, grid.mb_md)}>
                            {isTinkoffElevatorSettings(modBus.id)
                                ? translate('modBusElevatorSettings')
                                : translate('modBusWeatherSettings')}
                            :
                        </div>
                        <div className={styles.switchWrapper_}>
                            <SwitchButton
                                checked={modBus && modBus.enabledQ}
                                onChange={() => {
                                    onDataChange(modBus.id, !modBus.enabledQ, 'enabledQ')
                                }}
                                className={`test-settings-toggle_${modBus && modBus.enabledQ ? 'enabled' : 'disabled'}`}
                            />
                            <div className={cn(styles.switchCaption_)}>{translate('useModBus')}</div>
                        </div>
                        <div className={cn(styles.wrapper, !modBus.enabledQ ? styles.disabled : '')}>
                            <EditText
                                mod={'withBorder'}
                                className={styles.input}
                                label={translate('ipAddress')}
                                value={modBus && modBus.deviceIP}
                                onChange={(e: string) => {
                                    onDataChange(modBus.id, e, 'deviceIP')
                                }}
                                disabled={!modBus.enabledQ}
                            />
                        </div>
                        <div className={cn(styles.wrapper, !modBus.enabledQ ? styles.disabled : '')}>
                            <EditText
                                mod={'withBorder'}
                                className={styles.input}
                                label={translate('TCPPort')}
                                value={modBus && modBus.TCPPort}
                                onChange={(e: string) => {
                                    onDataChange(modBus.id, e, 'TCPPort')
                                }}
                                disabled={!modBus.enabledQ}
                            />
                        </div>
                        {isTinkoffElevatorSettings(modBus.id) && (
                            <div className={cn(styles.wrapper, !modBus.enabledQ ? styles.disabled : '')}>
                                <EditText
                                    mod={'withBorder'}
                                    className={styles.input}
                                    label={translate('registersQuantity')}
                                    value={modBus && modBus.registers}
                                    onChange={(e: string) => {
                                        onDataChange(modBus.id, e, 'registers')
                                    }}
                                    disabled={!modBus.enabledQ}
                                />
                            </div>
                        )}
                        <div className={cn(styles.wrapper, !modBus.enabledQ ? styles.disabled : '')}>
                            <EditText
                                mod={'withBorder'}
                                className={styles.input}
                                label={translate('scanRate')}
                                value={modBus && modBus.scanRate}
                                onChange={(e: string) => {
                                    onDataChange(modBus.id, e, 'scanRate')
                                }}
                                disabled={!modBus.enabledQ}
                            />
                        </div>
                        {isTinkoffElevatorSettings(modBus.id) && (
                            <>
                                <div className={cn(styles.wrapper, !modBus.enabledQ ? styles.disabled : '')}>
                                    <EditText
                                        mod={'withBorder'}
                                        className={styles.input}
                                        label={translate('startAddr')}
                                        value={modBus && modBus.startAddr}
                                        onChange={(e: string) => {
                                            onDataChange(modBus.id, e, 'startAddr')
                                        }}
                                        disabled={!modBus.enabledQ}
                                    />
                                </div>
                                <div className={cn(styles.wrapper, !modBus.enabledQ ? styles.disabled : '')}>
                                    <EditText
                                        mod={'withBorder'}
                                        className={styles.input}
                                        label={translate('registersLength')}
                                        value={modBus && modBus.registersLength}
                                        onChange={(e: string) => {
                                            onDataChange(modBus.id, e, 'registersLength')
                                        }}
                                        disabled={!modBus.enabledQ}
                                    />
                                </div>
                                <div className={cn(styles.wrapper, !modBus.enabledQ ? styles.disabled : '')}>
                                    <EditText
                                        mod={'withBorder'}
                                        className={styles.input}
                                        label={translate('floorDelta')}
                                        value={modBus && modBus.floorDelta}
                                        onChange={(e: string) => {
                                            onDataChange(modBus.id, e, 'floorDelta')
                                        }}
                                        disabled={!modBus.enabledQ}
                                    />
                                </div>
                                <div className={styles.switchWrapper_}>
                                    <SwitchButton
                                        checked={modBus.presenceZeroFloor}
                                        onChange={() => {
                                            onDataChange(modBus.id, !modBus.presenceZeroFloor, 'presenceZeroFloor')
                                        }}
                                        disabled={!modBus.enabledQ}
                                        className={`test-settings-toggle_${
                                            modBus.presenceZeroFloor ? 'enabled' : 'disabled'
                                        }`}
                                    />
                                    <div className={cn(styles.switchCaption_)}>
                                        <Typography type="title">{translate('presenceZeroFloor')}</Typography>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                ))}
        </div>
    )
}
